import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'stockName',
      label: '股票名称',
      type: 'input',
      placeholder: '请输入股票名称'
    },
    {
      field: 'stockCode',
      label: '股票代码',
      type: 'input',
      placeholder: '请输入股票代码'
    },
    {
      field: 'plateName',
      label: '板块名称',
      type: 'select',
      filterable: true,
      clearable: true,
      placeholder: '请输入板块名称',
      otherOptions: {
        changeField: 'stockTag',
        changeUrl: '/main/stock/getTagsByPlate',
        params: [{key: 'plateName', field: 'plateName'}]
      }
    },
    {
      field: 'stockTag',
      label: '概念名称',
      type: 'select',
      filterable: true,
      clearable: true,
      placeholder: '请输入概念名称',
    }, 
  ]
}
